import { ShaderFactory } from "./types"
import { Unit } from "../types"
import random from 'random-seed'

type ShaderProps = {
    spaces?: boolean
    release?: boolean
    symbols?: string[]
    speed?: number
}

const defaultSymbols = ['<', '>', '#', '#', '#', '*', '©', '@', 'H','U', 'G', 'O']

const useCryptWriter: ShaderFactory<ShaderProps> = ({ spaces = false, release = true, symbols = defaultSymbols, speed = 1 } = {}) => {
    return (input, tick) => {
        let offset = 0
        return input.map((row, y) => {
            return row.map((unit: Unit, x) => {
                offset++
                if (unit === ' ' && !spaces) return ' '
                if (offset < (tick * speed) && release) return unit
                return symbols[random.create(`${x}_${y}_${tick}`).range(symbols.length)]
            })
        })
    }
}

export default useCryptWriter
